import React, { useEffect, useState } from "react";
import ProjectManagerNavbar from "./ProjectNavBar";
import Sidebar from "../Sidebar/Index";
import Overview from "./Overview";
import Documents from "./Document";
import Members from "./Members";
import Posts from "./Posts";
import { useLocation } from "react-router";
import { setProject } from "../../../store/actions/actions";
import { projectList } from "../../data";
import { connect } from "react-redux";

const ProjectManager = (props) => {
  const nav_data = [
    {
      id: 1,
      name: "Overview",
      eventKey: "overview",
    },
    {
      id: 2,
      name: "Posts",
      eventKey: "posts",
    },
    {
      id: 3,
      name: "Documents",
      eventKey: "documents",
    },
    {
      id: 4,
      name: "Members",
      eventKey: "members",
    },
  ];

  useEffect(() => {
    props.setProject(projectList[0]);
  }, []);

  const [currentNavKey, setCurrentNavKey] = useState("overview");

  const { hash } = useLocation();
  useEffect(() => {
    nav_data.map((item, key) => {
      if (decodeURIComponent(hash) === `#${item.eventKey}`) {
        setCurrentNavKey(item.eventKey);
      }
      if (hash === "") {
        setCurrentNavKey("overview");
      }
    });
  }, [hash]);

  return (
    <>
      <div className="d-flex vh-100" style={{ background: "#232626" }}>
        {/* <EventNavbar /> */}
        <Sidebar />
        <div className="overflow-auto max-vh-100 p-4 w-100" id="style-4">
          <ProjectManagerNavbar
            setCurrentNavKey={setCurrentNavKey}
            navData={nav_data}
          />
          {currentNavKey === "overview" && <Overview />}
          {currentNavKey === "documents" && <Documents />}
          {currentNavKey === "members" && <Members />}
          {currentNavKey === "posts" && <Posts />}
        </div>
      </div>
    </>
  );
};
export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    project: state.project,
  }),
  { setProject }
)(ProjectManager);
